<div class="container">
  <h4>Camera Alerts</h4>
  <form>
    <div class="page-search mb-3">
      <div class="input-group">
        <input
          autofocus
          placeholder="Search Alerts"
          id="txtSearch"
          class="form-control"
          type="text"
          [formControl]="filter" />
        <button
          type="button"
          class="btn btn-sm btn-input-group"
          (click)="clearSearch()">
          <fa-icon [icon]="icons.times"></fa-icon>
        </button>
      </div>
      <button
        type="button"
        [routerLink]="['add']"
        class="btn btn-outline-info btn-sm d-none d-md-block"
        [disabled]="!adminService.isReady">
        <fa-icon [icon]="icons.add"></fa-icon>
      </button>
    </div>
  </form>
  <p>
    <a [routerLink]="['help']">How to I setup actions in Axis Camera Station</a>
  </p>
  <div>
    <ngb-alert
      type="info"
      [hidden]="this.adminService.isReady"
      [dismissible]="false"
      ><fa-icon [icon]="icons.spinner" animation="spin-pulse"></fa-icon>
      Reloading Alerts...</ngb-alert
    >
    <table
      class="table table-sm table-striped table-bordered table-row-detail table-hover">
      <thead class="table-dark">
        <tr>
          <th>
            <div class="clearfix">
              <div class="float-start pt-2">
                <span class="">Alert Name</span>
              </div>
              <div class="float-end">
                <button
                  type="button"
                  class="btn btn-sm btn-info d-block d-md-none"
                  [disabled]="!adminService.isReady"
                  [routerLink]="['add']">
                  <fa-icon [icon]="icons.add"></fa-icon>
                </button>
              </div>
            </div>
          </th>
          <th class="d-none d-md-table-cell">Site</th>
          <th class="d-none d-md-table-cell">Recipients</th>
          <th>Enabled</th>
          <th class="d-none d-md-table-cell">Trigger Url</th>
        </tr>
      </thead>
      <tbody>
        @for (alert of filteredAlerts | async; track alert; let i = $index) {
          <tr>
            <td [routerLink]="[alert.Id]">
              {{ alert.Name }}
            </td>
            <td [routerLink]="[alert.Id]" class="d-none d-md-table-cell">
              {{ alert.SiteName }}
            </td>
            <td [routerLink]="[alert.Id]" class="d-none d-md-table-cell">
              @for (rec of alert.Recipients; track rec) {
                <span>{{ rec.Name }}<br /></span>
              }
            </td>
            <td>
              <div class="form-check form-switch custom-switch-info">
                <input
                  #chkEnabled="ngModel"
                  [(ngModel)]="alert.Enabled"
                  type="checkbox"
                  (ngModelChange)="toggleAlert($event, alert.Id)"
                  class="form-check-input"
                  id="chkEnabled-{{ alert.Id }}"
                  name="chkEnabled-{{ alert.Id }}" />
                <label
                  class="form-check-label"
                  for="chkEnabled-{{ alert.Id }}"></label>
              </div>
            </td>
            <td class="d-none d-md-table-cell">
              <button
                type="button"
                class="btn btn-sm btn-outline-dark"
                (click)="copyTriggerUrl(alert.Id)">
                <fa-icon [icon]="icons.copy"></fa-icon>
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
